import { isLastDayOfMonth } from '@fukuri-admins/utils/common/date';
import type { CreateClientContractTermFormPresentation } from '../../presentations';

/**
 * converter が導出できる Presentation Props のみを対象にする
 *
 * searchAction / contractPlanSearchAction / isButtonDisabled / onSubmit / onCancel は
 * hooks 層が組み立てるハンドラ・状態であるため Omit で除外する。
 */
type PresentationProps = Omit<
  React.ComponentProps<typeof CreateClientContractTermFormPresentation>,
  'searchAction' | 'contractPlanSearchAction' | 'isButtonDisabled' | 'onSubmit' | 'onCancel'
>;

type IConvertToPresentationProps = () => PresentationProps;

/**
 * 企業契約期間 新規作成の Presentation Props を導出する
 *
 * - endedOnDisabledDate: サーバー側が月末日以外の終了日を受け付けないため、月末日以外を選択不可にする（PEN-1158）
 */
export const convertToPresentationProps: IConvertToPresentationProps = () => ({
  endedOnDisabledDate: date => !isLastDayOfMonth(date),
});
